module.exports = __webpack_public_path__ + "static/img/2areaA_33.b6443e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/2areaA_33.png
// module id = 1020
// module chunks = 1